import * as React from "react";

interface props {
  className?: string;
}
const DeleteIcon = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    className={className}
    viewBox="0 0 24 24"
  >
    <path
      fill="#B60100"
      d="M20.25 4.5H16.5v-.75a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 7.5 3.75v.75H3.75a.75.75 0 0 0 0 1.5h.75v13.5A1.5 1.5 0 0 0 6 21h12a1.5 1.5 0 0 0 1.5-1.5V6h.75a.75.75 0 1 0 0-1.5M10.5 15.75a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.5 0zm4.5 0a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0zM15 4.5H9v-.75A.75.75 0 0 1 9.75 3h4.5a.75.75 0 0 1 .75.75z"
    ></path>
  </svg>
);

export default DeleteIcon;
